import { render } from "./SidebarNavReferral.vue?vue&type=template&id=27da8bb1"
import script from "./SidebarNavReferral.vue?vue&type=script&lang=js"
export * from "./SidebarNavReferral.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__